<ng-container *ngIf="shouldShowDisclosure">
	<ng-container *ngIf="isExpandable">
		<section
			class="disclaimer-container margin-standard"
			(click)="toggleDisclosure()"
			custom-tracking
			[track-event]="'ac-disclosures:' + (isCollapsed ? 'expanded' : 'collapsed')"
		>
			<div class="disclosure-header text-12" data-cy="disclosure-disclosure-header">
				Disclaimer
				<icon type="chevron-double-down" class="icon" *ngIf="isCollapsed"></icon>
				<icon type="chevron-double-up" class="icon" *ngIf="!isCollapsed"></icon>
			</div>
			<div class="disclosure unselectable" [ngClass]="textClass" [class.faded]="isCollapsed" data-cy="disclosure-disclosure-content-expandable">
				<ng-container *ngTemplateOutlet="dcrContent"></ng-container>
			</div>
		</section>
	</ng-container>
	<ng-container *ngIf="!isExpandable">
		<div class="disclosure" [ngClass]="textClass" data-cy="disclosure-disclosure-content">
			<ng-container *ngTemplateOutlet="dcrContent"></ng-container>
		</div>
	</ng-container>
</ng-container>

<ng-template #dcrContent>
	<ng-container *ngIf="dcrKey; else ngContent">
		<div [dcrHTMLKey]="dcrKey">
			<span>{{ dcrKey }}</span>
		</div>
	</ng-container>
</ng-template>
<ng-template #ngContent><ng-content></ng-content></ng-template>
